import { render, staticRenderFns } from "./BankAccountV2.vue?vue&type=template&id=86eaca68"
import script from "./BankAccountV2.vue?vue&type=script&lang=js"
export * from "./BankAccountV2.vue?vue&type=script&lang=js"
import style0 from "./BankAccountV2.vue?vue&type=style&index=0&id=86eaca68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports